module.exports = __webpack_public_path__ + "img/yangan.ec440f9d.png";